
document.addEventListener('DOMContentLoaded', ()=>{
    ScrollEnlaces();
    validarFormulario();
});

function ScrollEnlaces(){
    const nav = document.querySelectorAll('#nav a');

    nav.forEach(navEnlace => {
        navEnlace.addEventListener('click', (e)=>{
            e.preventDefault();

                const enlaceHref = e.target.attributes.href.value;
                const scrollEnlace = document.querySelector(enlaceHref)
                scrollEnlace.scrollIntoView({behavior:'smooth'});
        });
    });
}

class UI{

    imprimirAlerta(mensaje, campo){
        this.limpiarAlerta(campo);
        const alerta = document.createElement('P');
        alerta.classList.add('alerta');
        alerta.textContent = mensaje;
        campo.appendChild(alerta);
    }

    limpiarAlerta(campo){
        const existeAlerta = campo.querySelector('.alerta')
        if(existeAlerta){
                existeAlerta.remove();
        }
    }

};

const ui = new UI;


function validarFormulario(){
    const nombre = document.querySelector('#nombre');
    const email = document.querySelector('#email');
    const mensaje = document.querySelector('#mensaje');
    const spinner = document.querySelector('#spinner');
    const btnEnviar = document.querySelector('#btnEnviar');
    const formulario = document.querySelector('#form');


    const datos = {
        nombre: '',
        email: '',
        mensaje: ''
    }

    nombre.addEventListener('blur', validarCampo);
    email.addEventListener('blur', validarCampo);
    mensaje.addEventListener('blur', validarCampo);
    btnEnviar.addEventListener('click', enviarFormulario);

    function validarCampo(e){
        const campo = e.target;
        if(campo.value.trim() === ''){
            ui.imprimirAlerta(`El campo ${campo.id} no se puede enviar vacio`, campo.parentElement);
            datos[e.target.id] = '';
            comprobarCampos();
            return;
        }

        if(campo.id === 'email' && !validarEmail(campo.value)){
            ui.imprimirAlerta('El email es incorrecto', campo.parentElement);
            datos[e.target.id] = '';
            comprobarCampos();
            return;
        }
        ui.limpiarAlerta(campo.parentElement);
        datos[e.target.id]= e.target.value.trim().toLowerCase();
        comprobarCampos();

    }


    function validarEmail(email){
        const regex =  /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
        const resultado = regex.test(email);
        return resultado;
    }

    function comprobarCampos(){
        if(Object.values(datos).includes('')){
            btnEnviar.classList.add('btnError');
            return;
        }
            btnEnviar.classList.remove('btnError');
    }

    function enviarFormulario(e){
        e.preventDefault();
        comprobarCampos();

        if(!Object.values(datos).includes('')){
            spinner.classList.add('mostrarSpinner');

            setTimeout(()=>{
                spinner.classList.remove('mostrarSpinner');
                reiniciarFormulario();
            },3000);
        }
        
    }

    function reiniciarFormulario(){
        formulario.reset();
        limpiarDatos();
    }

    function limpiarDatos(){
        datos.nombre = '';
        datos.email = '';
        datos.mensaje = '';
    }
}


